const HandleFormLoading = {
  loadingListener(this: any) {
    const submitBtn = this.el.querySelector("button[type='submit']");
    if (submitBtn) {
      const currentLabel = submitBtn.text;
      const loadingLabel =
        submitBtn.getAttribute("phx-disable-with") || "Saving...";
      this.handleEvent("start_loading", () => {
        submitBtn.disabled = true;
        submitBtn.innerHTML = loadingLabel;
      });

      this.handleEvent("stop_loading", () => {
        submitBtn.disabled = false;
        submitBtn.innerHTML = currentLabel;
      });
    }
  },
  mounted(this: any) {
    this.loadingListener();
  },
  updated(this: any) {
    this.loadingListener();
  },
};

export default HandleFormLoading;
